'use client';

// Last-resort boundary for errors thrown in the root layout itself, where the
// locale provider is unavailable. Must render its own <html>/<body>.
export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  // Suppress browser extension errors (e.g., MetaMask, crypto wallets)
  const isExtensionError = error.stack?.includes('chrome-extension://') || error.message?.includes('MetaMask');

  if (isExtensionError) {
    return (
      <html lang="en">
        <body style={{ background: '#1a2421' }} />
      </html>
    );
  }

  return (
    <html lang="en">
      <body
        style={{
          background: '#1a2421',
          color: '#dbe5e1',
          fontFamily: 'system-ui, sans-serif',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '24px',
        }}
      >
        <h1 style={{ fontSize: '24px', fontWeight: 700 }}>Something went wrong</h1>
        <p style={{ marginTop: '12px', color: '#c3c8c5' }}>
          An unexpected error occurred. Please try refreshing the page.
        </p>
        <button
          onClick={reset}
          style={{
            marginTop: '24px',
            padding: '12px 28px',
            borderRadius: '9999px',
            background: '#dbe5e1',
            color: '#1a2421',
            fontWeight: 700,
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
